export enum Page{
    LOGIN = '/login',
    ACTIVE_PROCESS = "/",
    DEVICE_TEST = '/devicetest',
    EXECUTE_PROCESS = '/executeprocess',
    HELP = '/help',
    ACTIVITY_LOGS = '/activitylogs',
    AUDIT_LOGS = '/auditlogs',
    PREVIOUS_PROCESS = '/previousactivities'
}